<template>
  <app-select
    filter
    :items="states"
    :label="$t('type')"
    label-icon="icon-vouchers"
    multiple
    hide-details
    dense
    solo
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'CreditorVoucherTypeSelect',

  computed: {
    states() {
      return Object.keys(this.product.creditorVoucherTypeGroups)
        .filter((type) => this.product.creditorVoucherTypeGroups[type]?.length > 0)
        .map((type) => ({
          label: this.$t(`masterData.creditorVouchers.creditorVoucherTypes.${type}`),
          value: type
        }));
    }
  }
};
</script>
